import api from '@/api/axiosApi'

export interface TextTemplateRead {
  slug: string
  content: string
  description: string | null
  updated_at: string | null
  updated_by: string | null
}

export interface TextTemplateUpdate {
  content: string
}

/**
 * GET /commitment-letters/template
 */
export async function getCommitmentLetterTemplate(): Promise<TextTemplateRead> {
  const response = await api.get<TextTemplateRead>(
    '/commitment-letters/template'
  )
  return response.data
}

/**
 * PUT /commitment-letters/template
 */
export async function updateCommitmentLetterTemplate(
  payload: TextTemplateUpdate
): Promise<TextTemplateRead> {
  const response = await api.put<TextTemplateRead>(
    '/commitment-letters/template',
    payload
  )
  return response.data
}
